import EditEvent from './EditEvent';

export default EditEvent;
